export default __webpack_public_path__ + "static/media/mina3.b6a47155.jpg";